module.exports = __webpack_public_path__ + "static/media/object-ungroup.ccaaf5e9.svg";